<template>
    <div>
        <div class="row">
            <div class="col-lg-6">
                <slot></slot>
                <div class="card">
                    <div class="card-header header-elements-inline bg-white">
                        <h5 class="card-title">E-postmall</h5>
                        <div class="header-elements justify-content-between flex-grow-1 pl-3">
                            <button
                                type="button"
                                class="btn btn-light btn-icon btn-sm"
                                @click="showModalHelp"
                            >
                                <i class="icon-info3"></i>
                            </button>
                            <div class="header-elements">
                                <div
                                    v-if="mode === 'normal'"
                                    class="custom-control custom-checkbox mr-3"
                                >
                                    <input type="checkbox" class="custom-control-input" id="chk-advanced" v-model="advanced">
                                    <label class="custom-control-label" for="chk-advanced">Avancerat</label>
                                </div>
                                <button type="button" class="btn btn-light" @click="showModalImportTemplate">Ersätt från mall</button>
                            </div>
                        </div>
                    </div>
                    <div v-if="localModel === null" class="card-body">
                        Välj vilken mall du vill utå ifrån
                        <button type="button" class="btn btn-light" @click="showModalImportTemplate">Välj mall</button>
                    </div>
                    <div v-else-if="(mode === 'normal' && advanced) || mode === 'advanced'" class="card-body">
                        <div class="ecard-template-blocks">
                            <template-block
                                type="Base"
                                @toggle-collapsible="base_open = !base_open"
                                :open="base_open"
                                class="mb-3"
                                locked
                            >
                                <div class="block-content-grid">
                                    <input-with-validation
                                        label="Max bredd"
                                        :vid="vid + '.width'"
                                        v-model="localModel.width"
                                        @input="emitChange"
                                        placeholder="Bredd"
                                    >
                                        <template v-slot:input-group-append>
                                            <span class="input-group-text">px</span>
                                        </template>
                                    </input-with-validation>
                                    <select-with-validation
                                        v-model="localModel.fontFamily"
                                        :vid="vid + '.fontFamily'"
                                        label="Font"
                                        :reduce="(opt) => opt.id"
                                        component="ecard-template-fonts-filter"
                                        :clearable="false"
                                        @option:selected="emitChange"
                                    ></select-with-validation>
                                    <input-with-validation
                                        label="Luft ovanför"
                                        :vid="vid + '.paddingTop'"
                                        v-model="localModel.paddingTop"
                                        @input="emitChange"
                                        placeholder="Luft ovanför"
                                    >
                                        <template v-slot:input-group-append>
                                            <span class="input-group-text">px</span>
                                        </template>
                                    </input-with-validation>
                                    <input-with-validation
                                        label="Luft under"
                                        :vid="vid + '.paddingBottom'"
                                        v-model="localModel.paddingBottom"
                                        @input="emitChange"
                                        placeholder="Luft under"
                                    >
                                        <template v-slot:input-group-append>
                                            <span class="input-group-text">px</span>
                                        </template>
                                    </input-with-validation>
                                    <input-with-validation
                                        label="Luft vänster"
                                        :vid="vid + '.paddingLeft'"
                                        v-model="localModel.paddingLeft"
                                        @input="emitChange"
                                        placeholder="Luft vänster"
                                    >
                                        <template v-slot:input-group-append>
                                            <span class="input-group-text">px</span>
                                        </template>
                                    </input-with-validation>
                                    <input-with-validation
                                        label="Luft höger"
                                        :vid="vid + '.paddingRight'"
                                        v-model="localModel.paddingRight"
                                        @input="emitChange"
                                        placeholder="Luft höger"
                                    >
                                        <template v-slot:input-group-append>
                                            <span class="input-group-text">px</span>
                                        </template>
                                    </input-with-validation>
                                </div>

                                <div class="form-group">
                                    <div class="custom-control custom-radio custom-control-inline">
                                        <div>Bakgrundstyp:</div>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline mb-2">
                                        <input type="radio" class="custom-control-input" name="bg_type" id="chk-bg-color" v-model="bg_type" value="color">
                                        <label class="custom-control-label" for="chk-bg-color">Färg</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline mb-2">
                                        <input type="radio" class="custom-control-input" name="bg_type" id="chk-bg-mediabank" v-model="bg_type" value="mediabank">
                                        <label class="custom-control-label" for="chk-bg-mediabank">Mediabank</label>
                                    </div>
                                    <div class="custom-control custom-radio custom-control-inline mb-2">
                                        <input type="radio" class="custom-control-input" name="bg_type" id="chk-bg-url" v-model="bg_type" value="url">
                                        <label class="custom-control-label" for="chk-bg-url">URL</label>
                                    </div>
                                </div>

                                <div
                                    v-if="bg_type === 'mediabank'"
                                    style="max-width: 200px;"
                                >
                                    <mediabank-selector
                                        v-model="localModel.bgMediaId"
                                        @input="emitChange"
                                        btn-class="btn-sm btn-secondary"
                                        btn-text="Välj bild från mediabank"
                                        btn-icon="icon-image2"
                                        thumbnail
                                        upload
                                    ></mediabank-selector>
                                </div>

                                <div v-if="bg_type === 'url' || bg_type === 'mediabank'">
                                    <input-with-validation
                                        label="Bild-URL"
                                        :vid="'view.bgUrl'"
                                        v-model="localModel.bgUrl"
                                        @input="emitChange"
                                        placeholder="https://examle.com/image.jpg"
                                    ></input-with-validation>

                                    <div class="block-content-grid">
                                        <select-with-validation
                                            v-model="localModel.bgPosition"
                                            :vid="'view.bgPosition'"
                                            label="Bakgrundsposition"
                                            :reduce="(opt) => opt.id"
                                            :options="[
                                                { label: 'center center', id: 'center center' },
                                                { label: 'center top', id: 'center top' },
                                                { label: 'center bottom', id: 'center bottom' },
                                            ]"
                                            :clearable="false"
                                            @option:selected="emitChange"
                                        ></select-with-validation>
                                        <select-with-validation
                                            v-model="localModel.bgRepeat"
                                            :vid="'view.bgRepeat'"
                                            label="Bakgrundsrepetition"
                                            :reduce="(opt) => opt.id"
                                            :options="[
                                                { label: 'no-repeat', id: 'no-repeat' },
                                                { label: 'repeat', id: 'repeat' },
                                                { label: 'repeat-y', id: 'repeat-y' },
                                                { label: 'repeat-x', id: 'repeat-x' },
                                            ]"
                                            :clearable="false"
                                            @option:selected="emitChange"
                                        ></select-with-validation>
                                        <select-with-validation
                                            v-model="localModel.bgSize"
                                            :vid="'view.bgSize'"
                                            label="Bildstorlek"
                                            :reduce="(opt) => opt.id"
                                            :options="[
                                                { label: 'Auto', id: 'auto' },
                                                { label: 'Fyll ut', id: 'cover' },
                                                { label: 'Anpassa', id: 'contain' },
                                            ]"
                                            :clearable="false"
                                            @option:selected="emitChange"
                                        ></select-with-validation>
                                    </div>
                                </div>
                                <color-picker
                                    v-else
                                    :vid="'view.backgroundColor'"
                                    label="Bakgrundsfärg"
                                    v-model="localModel.backgroundColor"
                                    @input="emitChange"
                                ></color-picker>
                            </template-block>
                        </div>

                        <draggable
                            v-model="localModel.blocks"
                            group="base"
                            handle=".handle"
                            class="ecard-template-blocks mb-3"
                            @sort="onSort"
                        >
                            <component
                                v-for="(block, b_index) in localModel.blocks"
                                :key="'b-' + block.id"
                                :vid="'view.blocks.' + b_index"
                                v-model="localModel.blocks[b_index]"
                                :is="'block-' + block.type"
                                :open="collapsible_state[block.id]"
                                @toggle-collapsible="toggleCollapsible(block.id)"
                                @delete="deleteBlock(block.id)"
                                @input="emitChange"
                                :mode="mode"
                            ></component>
                        </draggable>
                        <div class="btn-group justify-content-center">
                            <a href="#" class="btn btn-light dropdown-toggle" data-toggle="dropdown">Lägg till block</a>

                            <div class="dropdown-menu">
                                <a href="#" @click.prevent="addBlock('text')" class="dropdown-item">Text</a>
                                <a href="#" @click.prevent="addBlock('image')" class="dropdown-item">Bild</a>
                                <a href="#" @click.prevent="addBlock('hero')" class="dropdown-item">Hero</a>
                                <a href="#" @click.prevent="addBlock('redeem')" class="dropdown-item">Redeem</a>
                                <a href="#" @click.prevent="addBlock('button')" class="dropdown-item">Knapp</a>
                                <a href="#" @click.prevent="addBlock('section')" class="dropdown-item">Sektion</a>
                                <a href="#" @click.prevent="addBlock('divider')" class="dropdown-item">Avdelare</a>
                                <a href="#" @click.prevent="addBlock('spacer')" class="dropdown-item">Mellanrum</a>
<!--                                <a href="#" @click.prevent="addBlock('locked')" class="dropdown-item">Låst block</a>-->
<!--                                <a href="#" @click.prevent="addBlock('header')" class="dropdown-item">Header</a>-->
<!--                                <a href="#" @click.prevent="addBlock('footer')" class="dropdown-item">Footer</a>-->
                            </div>
                        </div>
                    </div>
                    <div v-else class="card-body">
                        <div class="ecard-template-blocks mb-3">
                            <component
                                v-for="entry in simpleEditableBlocks"
                                :key="'b-' + entry.block.id"
                                :vid="'view.blocks.' + entry.index"
                                :value="entry.block"
                                :is="'block-' + entry.block.type"
                                :open="true"
                                mode="simple"
                                @input="updateSimpleBlock(entry, $event)"
                            ></component>
                        </div>
                    </div>
                    <div class="card-footer bg-white">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="card">
                    <div class="card-header bg-white">
                        <h6 class="card-title">Preview</h6>
                    </div>
                    <div>
                        <iframe
                            v-if="preview && preview.html"
                            frameborder="0"
                            style="width: 100%; height: calc(100vh - 100px); overflow-x: hidden;"
                            ref="iframepreview"
                        ></iframe>
                    </div>
                </div>
            </div>
        </div>

        <b-modal
            id="modal_import_template"
            title="Välj mall"
            ok-title="Importera"
            cancel-title="Avbryt"
            cancel-variant="light"
            size="xl"
            @ok="importTemplate"
        >
            <div class="row">
                <div class="col-4">
                    <select-with-validation
                        label="Importera från epostmall"
                        component="ecard-template-filter"
                        v-model="import_template_id"
                        :reduce="(opt) => opt.id"
                        placeholder="Välj mall..."
                        :customer-id="customerId"
                        use-view
                    ></select-with-validation>
                    <div>Eller</div>
                    <select-with-validation
                        label="Importera från order"
                        component="card-order-filter"
                        v-model="import_template_from_order_id"
                        :reduce="(opt) => opt.id"
                        placeholder="Välj order..."
                        with-template-view
                    ></select-with-validation>
                </div>
                <div class="col-8">
                    <iframe
                        frameborder="0"
                        style="width: 100%; height: 50vh; overflow-x: hidden;"
                        ref="iframepreviewimport"
                    ></iframe>
                </div>
            </div>
        </b-modal>

        <b-modal
            id="modal_help"
            title="Hjälp"
            key="modal_help"
            ok-only
            scrollable
            ok-title="Stäng"
            ok-variant="light"
        >
            <div class="text-size-xl font-weight-semibold">Tillgängliga variabler</div>
            <ul class="list-unstyled">
                <li>##Subject##</li>
                <li>##SenderName##</li>
                <li>##GreetingText##</li>
                <li>##GreetingImage##</li>
                <li>##CardSerieImage##</li>
                <li>##GreetingLogo##</li>
                <li>##CardNo##</li>
                <li>##Email##</li>
                <li>##FirstName##</li>
                <li>##LastName##</li>
                <li>##FullName##</li>
                <li>##Company##</li>
            </ul>
        </b-modal>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import BlockButton from '@components/Ecard/BlockButton.vue';
import BlockDivider from '@components/Ecard/BlockDivider.vue';
import BlockHeader from '@components/Ecard/BlockHeader.vue';
import BlockHero from '@components/Ecard/BlockHero.vue';
import BlockFooter from '@components/Ecard/BlockFooter.vue';
import BlockImage from '@components/Ecard/BlockImage.vue';
import BlockSection from '@components/Ecard/BlockSection.vue';
import BlockSpacer from '@components/Ecard/BlockSpacer.vue';
import BlockRedeem from '@components/Ecard/BlockRedeem.vue';
import BlockText from '@components/Ecard/BlockText.vue';
import apiClient from '@services/ApiClient';
import { debounce } from 'lodash';
import InputWithValidation from '@components/Form/InputWithValidation.vue';
import ColorPicker from '@components/Form/ColorPicker.vue';
import MediabankSelector from '@components/MediabankSelector.vue';
import TemplateBlock from '@components/Ecard/TemplateBlock.vue';
import SelectWithValidation from '@components/Form/SelectWithValidation.vue';
import TextareaWithValidation from '@components/Form/TextareaWithValidation.vue';
import LimitlessButton from '@components/Limitless/LimitlessButton.vue';
import { genUUID } from '@services/Helpers';
import {
    sortBlocks,
} from '@services/EcardTemplateHelpers';
import PrintFormatFilter from '@components/Filters/PrintFormatFilter.vue';

export default {
    name: 'TemplateEditor',
    components: {
        PrintFormatFilter,
        LimitlessButton,
        TextareaWithValidation,
        SelectWithValidation,
        TemplateBlock,
        MediabankSelector,
        ColorPicker,
        InputWithValidation,
        draggable,
        BlockButton,
        BlockDivider,
        BlockHeader,
        BlockHero,
        BlockFooter,
        BlockImage,
        BlockSection,
        BlockSpacer,
        BlockRedeem,
        BlockText,
    },
    props: {
        value: {
            type: Object,
            default: null,
        },
        vid: {
            type: String,
            default: '',
        },
        customerId: {
            type: Number,
            default: null,
        },
        cardOrderId: {
            type: Number,
            default: null,
        },
        mode: {
            type: String,
            default: 'normal',
        },
    },
    data: () => ({
        preview: null,
        preview_import: null,
        localModel: null,
        base_open: false,
        collapsible_state: {},
        bg_type: 'color',
        import_template_id: null,
        import_template_from_order_id: null,
        advanced: false,
    }),
    mounted() {
        this.init(this.value);
        this.getPreview(this.cardOrderId);
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.init(newVal);
                this.getPreview(this.cardOrderId);
            },
        },
        import_template_id(newVal) {
            if (newVal) {
                this.import_template_from_order_id = null;
                this.getPreview(this.cardOrderId, '', newVal, true);
            }
        },
        import_template_from_order_id(newVal) {
            if (newVal) {
                this.import_template_id = null;
                this.getPreview(this.cardOrderId, newVal, '', true);
            }
        },
        bg_type(newVal) {
            if (!this.localModel) {
                return;
            }

            if (newVal === 'url') {
                this.localModel.bgMediaId = null;
            } else if (newVal === 'mediabank') {
                this.localModel.bgUrl = null;
            } else {
                this.localModel.bgUrl = null;
                this.localModel.bgMediaId = null;
            }
            this.emitChange();
        },
        'preview.html': function previewHtml(html) {
            if (html) {
                this.$nextTick(() => {
                    const iframe = this.$refs.iframepreview;
                    const doc = iframe.contentWindow.document;
                    doc.open();
                    doc.write(html);
                    doc.close();
                });
            }
        },
        'preview_import.html': function previewImportHtml(html) {
            if (html) {
                this.$nextTick(() => {
                    const iframe = this.$refs.iframepreviewimport;
                    const doc = iframe.contentWindow.document;
                    doc.open();
                    doc.write(html);
                    doc.close();
                });
            }
        },
    },
    computed: {
        simpleEditableBlocks() {
            if (!this.localModel || !Array.isArray(this.localModel.blocks)) {
                return [];
            }

            const isHiddenInSimpleMode = (block) => {
                if (!block) {
                    return false;
                }

                return (typeof block.locked === 'string' && block.locked !== '');
            };

            return this.localModel.blocks
                .map((block, index) => ({
                    block,
                    index,
                }))
                .filter(({ block }) => !isHiddenInSimpleMode(block));
        },
    },
    methods: {
        init(newVal) {
            if (newVal) {
                const state = {};
                if (newVal.blocks && Array.isArray(newVal.blocks)) {
                    newVal.blocks.forEach((b) => {
                        if (!Object.hasOwn(this.collapsible_state, b.id)) {
                            state[b.id] = false;
                        } else {
                            state[b.id] = this.collapsible_state[b.id];
                        }
                    });
                }
                this.collapsible_state = state;
                this.localModel = this.cloneModel(newVal);
                // eslint-disable-next-line no-nested-ternary
                this.bg_type = (newVal.bgMediaId > 0 ? 'mediabank' : ((newVal.bgUrl !== null && newVal.bgUrl !== '') ? 'url' : 'color'));
            } else {
                this.localModel = null;
            }
        },
        cloneModel(model) {
            return JSON.parse(JSON.stringify(model));
        },
        toggleCollapsible(blockId) {
            if (this.mode === 'simple') {
                return;
            }

            if (!Object.hasOwn(this.collapsible_state, blockId)) {
                this.collapsible_state[blockId] = false;
            }
            this.collapsible_state[blockId] = !this.collapsible_state[blockId];
        },
        addBlock(type) {
            if (this.mode === 'simple') {
                return;
            }

            this.localModel.blocks.push({
                id: genUUID(),
                type,
            });
            this.onSort();
        },
        deleteBlock(blockId) {
            if (this.mode === 'simple') {
                return;
            }

            const index = this.localModel.blocks.findIndex((b) => b.id === blockId);
            if (index > -1) {
                this.localModel.blocks.splice(index, 1);
                this.emitChange();
            }
        },
        getPreview: debounce(function getPreview(cardOrderId = '', cardOrderTemplateId = '', templateId = '', isImport = false) {
            const id = 0;
            apiClient.post(`/vue/ecard/recipients/${id}/preview?card_order_id=${cardOrderId > 0 ? cardOrderId : ''}&card_order_template_id=${cardOrderTemplateId > 0 ? cardOrderTemplateId : ''}&template_id=${templateId > 0 ? templateId : ''}`, { view: this.localModel }).then((res) => {
                if (isImport) {
                    this.preview_import = res.data.data;
                } else {
                    this.preview = res.data.data;
                }
            });
        }, 1000),
        emitChange() {
            this.$emit('input', this.cloneModel(this.localModel));
        },
        updateSimpleBlock(entry, value) {
            if (typeof entry.index === 'number' && Array.isArray(this.localModel.blocks)) {
                this.$set(this.localModel.blocks, entry.index, value);
                this.emitChange();
            }
        },
        onSort() {
            if (this.mode === 'simple') {
                return;
            }

            this.localModel.blocks = sortBlocks(this.localModel.blocks);
            this.emitChange();
        },
        showModalHelp() {
            this.$bvModal.show('modal_help');
        },
        showModalImportTemplate() {
            this.import_template_id = null;
            this.import_template_from_order_id = null;
            this.$bvModal.show('modal_import_template');
        },
        importTemplate() {
            if (this.import_template_id > 0) {
                apiClient.get('/vue/ecard/templates/' + this.import_template_id)
                    .then((response) => {
                        this.localModel = response.data.view;
                    })
                    .finally(() => {
                        this.emitChange();
                    });
            } else if (this.import_template_from_order_id > 0) {
                apiClient.get('/vue/cardorders/' + this.import_template_from_order_id + '/ecard_settings')
                    .then((response) => {
                        this.localModel = response.data.view;
                    })
                    .finally(() => {
                        this.emitChange();
                    });
            }
        },
    },
};
</script>
